import unionBy from 'lodash/unionBy';
import transform from 'lodash/transform';
import cloneDeep from 'lodash/cloneDeep';
import { AuditFacet, AuditLogOptions } from 'store/audit/types';
import { FiltersFormValues } from '../types/filter';
import { defaultValues } from './FiltersContext';

//
//  Constant: filtersReqDTO
//  Description: Transforms options to shape of filters values
//
export const filtersReqDTO = {
  filters: ({ filters }: AuditLogOptions) => {
    return transform(
      unionBy(filters, Object.values(defaultValues.filters), 'group'),
      (res, filter) => {
        res[filter.group] = filter;
      },
      {} as FiltersFormValues['filters']
    );
  },
  facets: ({ facets }: AuditLogOptions) => {
    return transform(
      facets || [],
      (res, facet) => {
        res[facet.group] = res[facet.group] ? [...res[facet.group], facet] : [facet];
      },
      cloneDeep(defaultValues.facets) as FiltersFormValues['facets']
    );
  }
};

//
//  Constant: filtersResDTO
//  Description: Transform filters values to shape of options
//
export const filtersResDTO = {
  filters: ({ filters }: FiltersFormValues) => Object.values(filters),
  facets: ({ facets }: FiltersFormValues) => {
    return transform<AuditFacet[], AuditLogOptions['facets']>(
      facets,
      (res, values) => {
        values.forEach(value => {
          res?.push(value);
        });
      },
      []
    );
  }
};
